<template>
  <v-snackbar
    v-if="activeSnackbar"
    :key="activeSnackbar.key"
    v-model="activeSnackbarModelValue"
    location="top right"
    v-bind="activeSnackbarProps"
    class="mt-16"
  >
    <div class="d-flex align-center">
      <v-icon v-if="activeSnackbar.icon" :icon="activeSnackbar.icon" :color="activeSnackbar.iconColor" class="mr-2" size="16px" />
      <component :is="activeSnackbar.iconComponent" v-else-if="activeSnackbar.iconComponent" class="mr-2" />
      <div v-if="activeSnackbar.text">
        <p
          v-for="(line) in activeSnackbarLines"
          :key="line"
        >
          {{ line }}
        </p>
      </div>
      <component
        :is="activeSnackbar.textComponent"
        v-else-if="activeSnackbar.textComponent"
      />
    </div>
  </v-snackbar>
</template>

<script setup>
import { useAppSnackbar } from '@/stores/app/snackbar';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const { snackbarQueue, activeSnackbar } = storeToRefs(useAppSnackbar());
const { setSnackbarQueue } = useAppSnackbar();

const activeSnackbarModelValue = computed({
  get: () => activeSnackbar.value?.modelValue,
  set: (val) => {
    if (activeSnackbar.value) {
      const newQueue = [...snackbarQueue.value];

      newQueue[0].modelValue = val;
      setSnackbarQueue(newQueue);

      if (!val) {
        if (newQueue[0].onRemoved) newQueue[0].onRemoved();
        setSnackbarQueue(snackbarQueue.value.slice(1));
      }
    }
  },
});

const activeSnackbarProps = computed(() => {
  const {
    location, modelValue, icon, iconComponent, text, textComponent, iconColor, ...rest
  } = activeSnackbar.value || {};
  return rest;
});

const activeSnackbarLines = computed(() => {
  const text = activeSnackbar.value?.text;

  if (!text) {
    return [];
  }

  if (!activeSnackbarProps.value?.multiline) {
    return [text];
  }

  return text.split('\n').map((line) => line.trim()).filter(Boolean);
});
</script>

<style scoped>
:global(.v-snackbar__wrapper) {
  min-height: 0 !important;
  border-radius: 32px !important;
  right: 16px;
}

:global(.v-snackbar__content) {
  padding: 8px 12px !important;
}

:deep(p) {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
}
</style>
